module.exports = __webpack_public_path__ + "img/slide11.1adb1c53.png";